import axios from './fetch'

export const getList = (addr, chainid) => {
  return axios.get(`/api/User/getApproval`, {
    params: {
      addr,
      chainid,
    },
  })
}

export const getAddrName = (addr, chainid) => {
  return axios.get(`/api/User/getName`, {
    params: {
      addr,
      chainid,
    },
  })
}

export const reportBug = (type, url, describe) => {
  return axios.get(`/api/User/reportBug`, {
    params: {
      type,
      url,
      describe,
    },
  })
}
